enum CRUDActions {
    CREATE = 'CREATE',
    REQUEST = 'REQUEST',
    UPDATE = 'UPDATE',
    UPDATE_CREATE = 'UPDATE_CREATE',
    DELETE = 'DELETE'
}
export default CRUDActions;